/**
 * Whitepaper download gate.
 *
 * The download link stays hidden until the embedded Dynamics 365 marketing
 * form dispatches `d365mkt-afterformsubmit`. Clicking the revealed link
 * pushes a `whitepaper_download` event to the GTM dataLayer, matching the
 * tracking the old site sent via gtag.
 */
class WhitepaperGate {
	/**
	 * Attach the form-submit and click listeners when a gate is on the page.
	 */
	init() {
		if ( ! document.querySelector( '[data-whitepaper-gate]' ) ) {
			return;
		}

		document.addEventListener( 'd365mkt-afterformsubmit', event => this.onFormSubmit( event ) );
		document.addEventListener( 'click', event => this.onClick( event ) );
	}

	/**
	 * Reveal the download link(s) after a successful form submission.
	 *
	 * @param {CustomEvent} event - The Dynamics after-submit event.
	 */
	onFormSubmit( event ) {
		// Explicit successful:true (not just !== false) so a failed or malformed
		// submission can't unlock the download — confirmed against the live form.
		if ( ! event.detail || event.detail.successful !== true ) {
			return;
		}

		// Give the form a moment to show its own confirmation message (matches the old site's 1s delay).
		window.setTimeout( () => this.revealDownloads(), 1000 );
	}

	/**
	 * Set the real PDF URL on the download links and unhide them.
	 */
	revealDownloads() {
		const gates = document.querySelectorAll( '[data-whitepaper-gate]' );

		gates.forEach( gate => {
			const ready = gate.querySelector( '[data-whitepaper-ready]' );
			const link = gate.querySelector( '[data-whitepaper-download]' );
			const fileUrl = gate.getAttribute( 'data-whitepaper-file' );

			if ( ! ready || ! link || ! fileUrl ) {
				return;
			}

			link.setAttribute( 'href', fileUrl );
			ready.removeAttribute( 'hidden' );
		} );

		const firstReady = document.querySelector( '[data-whitepaper-ready]:not([hidden])' );
		if ( firstReady ) {
			firstReady.scrollIntoView( { behavior: 'smooth', block: 'nearest' } );
		}
	}

	/**
	 * Track clicks on the revealed download link.
	 *
	 * @param {MouseEvent} event - The click event.
	 */
	onClick( event ) {
		const link = event.target.closest( '[data-whitepaper-download]' );

		if ( ! link ) {
			return;
		}

		const gate = link.closest( '[data-whitepaper-gate]' );
		const titleElement = gate ? gate.querySelector( '.whitepaper-download-gate__title' ) : null;
		const titleText = titleElement ? titleElement.textContent.trim() : '';
		const title = titleText !== '' ? titleText : document.title;

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push( {
			event: 'whitepaper_download',
			whitepaperTitle: title,
		} );
	}
}

new WhitepaperGate().init();
